/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
	  }
export type Hour = number & { readonly __brand: unique symbol }
export type Minute = number & { readonly __brand: unique symbol }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string }
	String: { input: string; output: string }
	Boolean: { input: boolean; output: boolean }
	Int: { input: number; output: number }
	Float: { input: number; output: number }
	/** Date (isoformat) */
	Date: { input: string; output: string }
	/** Date with time (isoformat) */
	DateTime: { input: string; output: string }
	Hour: { input: Hour; output: Hour }
	Minute: { input: Minute; output: Minute }
	join__FieldSet: { input: string; output: string }
	link__Import: { input: string; output: string }
}

export type CanceledReservation = {
	canReserveCanceledReservationMenusSet: Scalars["Boolean"]["output"]
	cancelId: Scalars["String"]["output"]
	customer: Customer
	durationMinute: Scalars["Int"]["output"]
	menusAndCoupons: MenusAndCoupons
	price: Scalars["Int"]["output"]
	staff: Maybe<Staff>
	useClaimingConversionRecancelPolicy: Scalars["Boolean"]["output"]
}

export type CanceledReservationParam = {
	cancelId: Scalars["String"]["input"]
}

export type CanceledReservationResponse = {
	canceledReservation: CanceledReservation
	isRereserved: Scalars["Boolean"]["output"]
	salon: Salon
}

export type CanceledReservationV2 = {
	/**
	 * CanceledReservationV2は、キャンセルされた予約を再予約するための情報を返します。
	 * - TODO: add description
	 * - key にある cancy から渡ってくる値は、scrapeCancelsAndReservations で nabeko が返している値が渡ってきます。
	 *   - 例えば、all_booking_platforms のキャンセルは、Staff は SB, dataSource は SB or Minimo or Rakuten
	 */
	_nabekoInfo: Scalars["Boolean"]["output"]
	cancelId: Scalars["String"]["output"]
	couponNames: Array<Scalars["String"]["output"]>
	dataSource: DataSource
	durationMinute: Scalars["Int"]["output"]
	/**
	 * 再予約時の機能の有効/無効の情報を返します
	 * - menu_and_staff_mappings から各 menuName に対応する staffID と、coupon_and_staff_mappings から各 couponName に対応する staffID の両方に含まれる staffID を用いて、staffs テーブルからスタッフ情報を返します。
	 *   - これらのテーブル（staffs、menu_and_staff_mappings、coupon_and_staff_mappings）は、NabekoPrivateService/ScrapeCancelsAndReservations APIが呼び出された時に内部で作成されます。そのため、まだ作成されていない場合、treatableStaffsには前回キャンセルされた予約を担当していたスタッフの情報（staff）のみが返されます。
	 *   - data source policy が cloud beauty の場合、NabekoPrivateService/ScrapeCancelsAndReservations APIが呼び出されても、内部でstaffs、menu_and_staff_mappings、coupon_and_staff_mappingsテーブルは作成されません。そのため、treatableStaffsは空の配列を返します。
	 *
	 * - [媒体固有の処理 (Salon.dataSourcePolicy によって変化)]
	 *   - [exceed]
	 *     - exceed の staff id, name が帰ることに注意。(予約枠は SB から取るが、staff id, name はエクシードのものに差し替える)
	 *   - [all_booking_platforms] dataSource によって変化
	 *     - salonboard: 通常通り計算
	 *     - minimo: minimo の MCSM を使用して施術可能 staff を計算したのち、
	 *       data_source_staff_mappings で SB のスタッフにマッピングし、SB の id name を返す。(mapping がなければそもそも返さない)
	 *     - rakuten: rakuten は staffs のみ作成されており、それら全ての staff が全メニュー施術可能とする。
	 *       minimo と同様 data_source_staff_mappings で SB の id name を返す
	 */
	enabledFeatures: ReservationPageEnabledFeatures
	equipmentIds: Array<Scalars["String"]["output"]>
	/** feature flag HIDE_STAFF_FOR_NOT_NOMINATED_RERESERVATION が ON かつ is_nominated=false のとき true。FE は true のとき再予約画面 (上部カード・予約確定の確認モーダル) の「指名スタッフ」欄を表示しない (KLP 等、フリー staff が無く指名なしでも特定 staff に紐づく媒体で「指名していないのに【前回指名】」と読ませないため)。false なら従来どおり「【前回指名】{staff.name}」。予約の作成内容には影響しない。 */
	hidesStaffDueToNotNominated: Scalars["Boolean"]["output"]
	/** 再予約 incentive 情報 (zina 限定)。incentive 対象外サロンでは null。FE が新デザイン (えらべるPay / 500円OFF バナー) を出すために使う。 */
	incentive: Maybe<RereservationIncentiveOutput>
	menuNames: Array<Scalars["String"]["output"]>
	menuOrCouponNames: Array<Scalars["String"]["output"]>
	price: Scalars["Int"]["output"]
	/** 再予約完了画面のフォームでお客様自身が登録したメールアドレス。未登録なら null。LOTTERY の「メール登録で当選口数 2 倍」が実際に適用される条件 (当選者選定時に email_source=rereservation_form のくじ券へ倍率を掛ける) と同じ条件で返すので、FE は null かどうかで「2 倍が適用されています」表示に切り替え、値を登録済みアドレスとして出す。この画面から本人が登録したアドレスだけを返す (上野クリニックの入力シート由来 (scraping) や請求書画面 (payment_form) のアドレスは含まない)。 */
	registeredEmailByRereservationForm: Maybe<Scalars["String"]["output"]>
	reserveId: Scalars["String"]["output"]
	salonId: Scalars["Int"]["output"]
	staff: StaffV2
	/** キャンセルされた予約と同じメニュー/クーポンを施術可能なスタッフの情報を返します */
	treatableStaffs: Array<TreatableStaff>
	useClaimingConversionRecancelPolicy: Scalars["Boolean"]["output"]
	/** お客様の来店回数。FE は visit_count >= 1 のリピーターには他スタッフの予約枠を表示しない。 */
	visitCount: Scalars["Int"]["output"]
	visitDate: Scalars["Date"]["output"]
}

/**
 * CanceledReservationV2 query は、前回のメニューを取得します
 *
 * [error]
 * - TODO:
 * - salon_answer 店舗ではない場合
 */
export type CanceledReservationV2Param = {
	cancelId: Scalars["String"]["input"]
}

export type CanceledReservationV2Response = {
	canceledReservation: CanceledReservationV2
	customer: Customer
	isAbortingEncouragingRereservationEnabled: Scalars["Boolean"]["output"]
	isRereserved: Scalars["Boolean"]["output"]
	salon: SalonV2
}

/**
 * エラーが起きた際、ユーザー側で解決可能なエラーのときは
 * extensions.code でエラーコードを返し、message で human readable なエラーメッセージを返す。
 * その際、取り得るエラーコードがUserErrorCodeである。
 *
 * - フロントエンドにどんなエラーコード文字列が返りうるかを一覧で伝えるため、型定義をしているが、UserErrorCodeという型を返すAPI自体があるわけではない。
 */
export type CancyPublicRereservationSubgraphUserErrorCode =
	| "INVALID_EMAIL_FORMAT"
	| "SLOT_UNAVAILABLE_TO_CREATE_RESERVATION"

/**
 * CreateRereservationInput は、再予約を作成するためのパラメータ。
 *
 * - cancel_id: キャンセルID
 * - use_canceled_reservation_menu_set: キャンセルした予約のメニューセットを使用するかどうか
 * - staff_id: 指定するスタッフID (任意)
 * - start_time: 予約開始時間
 * - duration_minute: 予約時間(分)
 */
export type CreateRereservationInput = {
	cancelId: Scalars["String"]["input"]
	durationMinute: Scalars["Int"]["input"]
	staffId?: InputMaybe<Scalars["String"]["input"]>
	startTime: Scalars["DateTime"]["input"]
	useCanceledReservationMenuSet: Scalars["Boolean"]["input"]
}

export type CreateRereservationResponse = {
	rereservation: Rereservation
}

/**
 * CreateRereservation mutation は、再予約を作成します。
 * - enableSlotCaching feature が有効な店舗の場合: 該当の予約枠が空いているか確認し、空いている場合は再予約を作成します。
 * - 前回のメニューで予約を作成します
 * - 再予約確定時に,サロンに紐づいているユーザーに再予約確定メールが非同期で送られます。
 *
 * [equipment_ids の渡し方]
 * - needSameEquipmentAsPreviousToCreateReservation=true の場合: 前回予約と同じ equipment IDs すべてを渡す
 * - needAnyReservableEquipmentToCreateReservation=true の場合: 予約可能な設備ID を一つだけ渡す
 * - どちらも false の場合: 空配列を渡す（設備予約不要）
 * - TODO: サーバー側での validation（flag と equipment_ids の整合性チェック）
 * - TODO: needAny のときも、前回複数の設備の予約だった場合の考慮をする
 *
 * [error]
 * - CancyPublicRereservationSubgraphUserErrorCode.SLOT_UNAVAILABLE_TO_CREATE_RESERVATION: enableSlotCaching feature が有効な店舗の場合、該当の予約枠が空いていない場合に返す。
 * - TODO:
 * - salon_answer 店舗ではない場合
 */
export type CreateRereservationV2Input = {
	cancelId: Scalars["String"]["input"]
	equipmentId?: InputMaybe<Scalars["String"]["input"]>
	equipmentIds?: Array<Scalars["String"]["input"]>
	scrapingTargetSiteStaffId: Scalars["String"]["input"]
	staffName: Scalars["String"]["input"]
	startTime: Scalars["DateTime"]["input"]
}

export type CreateRereservationV2Response = {
	rereservation: RereservationV2
}

/**
 * CreateUenoRereservationRequest mutation は、上野クリニック専用の再来カウンセリング予約受付として、
 * 再予約の希望枠 (最大2) を受け付けます。
 *
 * - 「確定」ではなく「受付 (リクエスト)」であり、この時点では媒体への実予約は作成されません。
 *   確定済み再予約を作成する CreateRereservationV2 とは別のフローです。
 * - 上野クリニックの店舗 (data_source で判定) でのみ使用します。
 * - secondStartTime は任意です (未指定 = 1枠のみの受付)。
 * - 同一 cancel_id で既に受付済みの場合は、既存の受付内容をそのまま返します (冪等)。
 */
export type CreateUenoRereservationRequestInput = {
	cancelId: Scalars["String"]["input"]
	firstStartTime: Scalars["DateTime"]["input"]
	secondStartTime?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type CreateUenoRereservationRequestResponse = {
	uenoRereservationRequest: UenoRereservationRequestV1
}

export type Customer = {
	/** scraping_target_site_customer_id_by_cancel_id */
	id: Scalars["String"]["output"]
	name: Scalars["String"]["output"]
	/** お客様の電話番号。canceledReservationV2 等で予約元データに含まれる場合のみ値が入る。 */
	phoneNumber: Maybe<Scalars["String"]["output"]>
}

export type DataSource =
	| "BEAUTY_MERIT"
	| "CLOUD_BEAUTY"
	| "EXCEED_SYSTEM"
	| "KANZASHI"
	| "MINIMO"
	| "POSTAS"
	| "RAKUTEN_BEAUTY"
	| "SALONBOARD"
	| "SALON_ANSWER"
	| "SALON_CONNECT"
	| "SALORIZA"
	| "UENO_CLINIC_SPREAD_SHEET"

export type DateReservableSlots = {
	date: Scalars["Date"]["output"]
	reservableEndHour: Scalars["Hour"]["output"]
	reservableEndMinute: Scalars["Minute"]["output"]
	reservableSlotsWithStaffChunks: Array<ReservableSlotsWithStaffChunk>
	reservableSlotsWithoutStaff: Array<ReservableSlot>
	reservableStartHour: Scalars["Hour"]["output"]
	reservableStartMinute: Scalars["Minute"]["output"]
}

export type DateReservableSlotsV2 = {
	date: Scalars["Date"]["output"]
	reservableEndHour: Scalars["Hour"]["output"]
	reservableEndMinute: Scalars["Minute"]["output"]
	reservableSlotsWithEquipmentChunks: Array<ReservableSlotsWithEquipmentChunkV2>
	reservableSlotsWithStaffChunks: Array<ReservableSlotsWithStaffChunkV2>
	reservableStartHour: Scalars["Hour"]["output"]
	reservableStartMinute: Scalars["Minute"]["output"]
}

export type Equipment = {
	id: Scalars["String"]["output"]
	name: Scalars["String"]["output"]
}

/**
 * MarkLotteryTicketAsShown mutation は、くじ券 (抽選の案内) をお客様に見せたことを記録する。
 *
 * - 当選口数はくじ券の発行時 (キャンセル検知時) に確定済みなので、この mutation で結果は変わらない。
 *   記録するのは「お客様が抽選の案内を見た」という事実だけ
 *   (くじ券の発行数と、実際に見せられた数を分けて測るため)。
 * - 見せ方 (現状は再予約画面のルーレット演出) は変わりうるため、何で見せたかは記録しない。
 * - 1 人のお客様に見せるのは 1 回。同じ画面を開き直して何度呼んでも最初に見せた時刻を保つ (冪等)。
 * - LOTTERY 以外の cancel にはくじ券が無いため、呼んでも何も記録されない (エラーにはしない)。
 */
export type MarkLotteryTicketAsShownInput = {
	cancelId: Scalars["String"]["input"]
}

export type MarkLotteryTicketAsShownResponse = {
	cancelId: Scalars["String"]["output"]
}

export type MenusAndCoupons = {
	names: Array<Scalars["String"]["output"]>
}

export type Mutation = {
	createRereservation: CreateRereservationResponse
	/**
	 * CreateRereservationV2Input の情報で予約を作成します.
	 *
	 * [再予約 incentive (encourage_rereservation_reminders.incentive) の扱い]
	 * incentive は reminder 作成時に RereservationIncentive.new(salon_id, origin_price, base_time) で解決される.
	 * 対象は zina グループ（special_salons.zina_salon_ids）が DISCOUNT 固定、それ以外の全店舗が GIFT 固定で、
	 * いずれも price=500 の incentive が付与される. zina は origin_price==0 のとき DISCOUNT を当てられないため
	 * incentive 未設定（None）になる. 上記条件外の cancel では incentive 未設定（None）となり、
	 * 通常通り元金額で予約を作成する.
	 *
	 * - incentive_type='gift' (例: Amazon ギフトカード 500 円):
	 *     - 予約金額は元のまま変更しない. 媒体上の予約価格・rereservations.price はいずれも元金額.
	 *     - ギフトカードは予約フローの外で運用上手動配布する（本 GraphQL の責務範囲外）.
	 *     - 予約確定メールが gift 用 BCC（slack 転送先）にも転送され、担当が手動でギフトカード送信を行う.
	 *     - TODO: 再予約案内 SMS の文面切替, メール登録時メールの文面切替は未実装。
	 *       gift incentive 用の専用 message_sending_policy_id を用意してから対応する。
	 *
	 * - incentive_type='discount':
	 *     - 媒体への予約金額を「元金額 - discount_price」に減額して booking する
	 *       （例: 元金額 17400 円, planned 値引き 500 円 → 媒体上は 16900 円で予約作成）.
	 *     - 元金額より値引き額が大きい場合は元金額を上限に丸める (例: 元金額 400 円 / planned 500 円 → 実値引き 400 円).
	 *     - 実値引きが 0 になるケース (origin_price=0 等) は RereservationIncentive.new 時点で incentive を
	 *       付与しないため、ここでは発生しない. 万一発生した場合 (reminder 作成後に origin_price が 0 になった等) は
	 *       compute_actual_discount_price が ValueError を上げて即時検知する.
	 *     - rereservations.price には**値引き前**の元金額を保存し、rereservations.discount_price に
	 *       実際に値引きされた額（元金額を上限に丸めた額）を別途記録する.
	 *     - 確定メールは discount 用 template (件名/本文に値引き案内を含む) に切り替わる.
	 *     - TODO: 再予約案内 SMS の文面切替, メール登録時メールの文面切替は未実装。
	 *       discount incentive 用の専用 message_sending_policy_id を用意してから対応する。
	 */
	createRereservationV2: CreateRereservationV2Response
	/**
	 * CreateUenoRereservationRequest mutation は、上野クリニック専用の再来カウンセリング予約受付として、
	 * 顧客の再予約希望枠 (最大2) を受け付けます。
	 *
	 * - 「確定」ではなく「受付 (リクエスト)」であり、この時点では媒体への実予約は作成されません。
	 * - 同一 cancel_id で既に受付済みの場合は、既存の受付内容をそのまま返します (冪等)。
	 */
	createUenoRereservationRequest: CreateUenoRereservationRequestResponse
	/**
	 * MarkLotteryTicketAsShown mutation は、抽選 (LOTTERY) のくじ券 (抽選の案内) を
	 * お客様に見せたことを、そのキャンセルのくじ券 (lottery_tickets.shown_time) に記録します。
	 *
	 * 当選口数はくじ券の発行時に確定済みなので、この mutation を呼んでも結果は変わりません。
	 * 同じ画面を開き直して何度呼んでも、最初に見せた時刻を保ちます (冪等)。
	 */
	markLotteryTicketAsShown: MarkLotteryTicketAsShownResponse
	upsertRereservedCustomerEmail: UpsertRereservedCustomerEmailResponse
}

export type MutationCreateRereservationArgs = {
	input: CreateRereservationInput
}

export type MutationCreateRereservationV2Args = {
	input: CreateRereservationV2Input
}

export type MutationCreateUenoRereservationRequestArgs = {
	input: CreateUenoRereservationRequestInput
}

export type MutationMarkLotteryTicketAsShownArgs = {
	input: MarkLotteryTicketAsShownInput
}

export type MutationUpsertRereservedCustomerEmailArgs = {
	input: UpsertRereservedCustomerEmailInput
}

export type Query = {
	Rereservation: Rereservation
	canceledReservation: CanceledReservationResponse
	canceledReservationV2: CanceledReservationV2Response
	/**
	 * DO NOT call this query.
	 * this field is not for executing query, but only for showing possible UserErrorCode enum value to frontend client.
	 */
	cancyPublicRereservationSubgraphUserErrorCode: CancyPublicRereservationSubgraphUserErrorCode
	rereservationV2: RereservationV2Response
	sevenDaysReservableSlotsChunks: SevenDaysReservableSlotsChunksResponse
	sevenDaysReservableSlotsChunksV2: SevenDaysReservableSlotsChunksV2Response
	uenoRereservationRequestV1: UenoRereservationRequestV1Response
}

export type QueryRereservationArgs = {
	param: RereservationParam
}

export type QueryCanceledReservationArgs = {
	param: CanceledReservationParam
}

export type QueryCanceledReservationV2Args = {
	param: CanceledReservationV2Param
}

export type QueryRereservationV2Args = {
	param: RereservationV2Param
}

export type QuerySevenDaysReservableSlotsChunksArgs = {
	param: SevenDaysReservableSlotsChunksParam
}

export type QuerySevenDaysReservableSlotsChunksV2Args = {
	param: SevenDaysReservableSlotsChunksV2Param
}

export type QueryUenoRereservationRequestV1Args = {
	param: UenoRereservationRequestV1Param
}

export type RecommendedSlot = {
	date: Scalars["Date"]["output"]
	/** TODO: needAnyReservableEquipmentToCreateReservation が True の場合のみ返される */
	equipment: Maybe<Equipment>
	slot: ReservableSlotV2
	staff: StaffV2
}

export type Rereservation = {
	cancelId: Scalars["String"]["output"]
	customer: Customer
	durationMinute: Scalars["Int"]["output"]
	id: Scalars["String"]["output"]
	menusAndCoupons: MenusAndCoupons
	price: Scalars["Int"]["output"]
	salon: Salon
	staff: Maybe<Staff>
	startTime: Scalars["DateTime"]["output"]
	useClaimingConversionRecancelPolicy: Scalars["Boolean"]["output"]
}

/**
 * RereservationIncentiveOutput は、対象 cancel に紐づく再予約 incentive 情報。
 * - price: incentive 価格 (DISCOUNT のとき値引き想定額、GIFT / GIFT_CANDIDATE のときギフト額、LOTTERY のとき賞金額)
 * - type: incentive 種別 (GIFT / DISCOUNT / LOTTERY / GIFT_CANDIDATE)
 * - lottery_id: LOTTERY のときどの抽選のくじ券か。それ以外は null
 * - lottery_multiplier: LOTTERY のときルーレットで確定した当選口数 (倍率)。それ以外は null
 * - lottery_shown: LOTTERY のときくじ券 (抽選の案内) をすでにお客様に見せたか。それ以外は null
 */
export type RereservationIncentiveOutput = {
	/** LOTTERY のとき、どの抽選のくじ券かを表す id (例: rereservation_100k)。再予約側・請求側で別々の抽選を回すため、くじ券がどの抽選のものか識別できるようにしている。くじ券 (lottery_tickets) の値をそのまま返す。LOTTERY 以外では null。 */
	lotteryId: Maybe<Scalars["String"]["output"]>
	/** LOTTERY のときお客様に適用される当選口数 (倍率)。キャンセル検知時にくじ券 (lottery_tickets) を発行して 1 回だけ引いた値を返すため、何度アクセスしても同じ値になる (ルーレットは 1 人 1 回)。メール登録による倍率 UP は含まない (base_multiplier をそのまま返す)。倍率 UP が適用済みかは registered_email_by_rereservation_form で判定し、実際の当選口数への反映は当選者選定時に行う。LOTTERY 以外では null。 */
	lotteryMultiplier: Maybe<Scalars["Int"]["output"]>
	/** LOTTERY のとき、くじ券 (抽選の案内) をすでにお客様に見せたか。1 人のお客様に見せるのは 1 回なので、true なら端末・ブラウザが変わっても見せる演出 (現状はルーレット) は出さず結果表示に直行する。FE が MarkLotteryTicketAsShown mutation を呼ぶと true になる。LOTTERY 以外・くじ券なしでは null。 */
	lotteryShown: Maybe<Scalars["Boolean"]["output"]>
	price: Scalars["Int"]["output"]
	type: RereservationIncentiveTypeEnum
}

/**
 * RereservationIncentiveType は、再予約 incentive の種別を表す。
 * - GIFT: えらべるPay などのギフト (incentive 価格分が後日もらえる)
 * - DISCOUNT: 値引き (incentive 価格を予約金額から差し引く)
 * - LOTTERY: 抽選キャンペーン (price は当選者 1 名が受け取る賞金額)。
 *   FE は再予約画面でルーレットを回させ、確定した当選口数 (lotteryMultiplier) を表示する。
 * - GIFT_CANDIDATE: ギフト候補 (もらえるかもしれない 1,000 円ギフト)。price は配ると決まったときに
 *   受け取る額。配るかどうかは来店後に決まるため、FE は「必ずもらえる」とは表示しない。
 */
export type RereservationIncentiveTypeEnum =
	| "DISCOUNT"
	| "GIFT"
	| "GIFT_CANDIDATE"
	| "LOTTERY"

export type RereservationParam = {
	cancelId: Scalars["String"]["input"]
}

export type RereservationV2 = {
	cancelId: Scalars["String"]["output"]
	customer: Customer
	durationMinute: Scalars["Int"]["output"]
	equipmentId: Maybe<Scalars["String"]["output"]>
	menuOrCouponNames: Array<Scalars["String"]["output"]>
	price: Scalars["Int"]["output"]
	salon: SalonV2
	staff: StaffV2
	startTime: Scalars["DateTime"]["output"]
	useClaimingConversionRecancelPolicy: Scalars["Boolean"]["output"]
}

/** - TODO: */
export type RereservationV2Param = {
	cancelId: Scalars["String"]["input"]
}

export type RereservationV2Response = {
	/** 確定済み再予約。上野クリニック (受付フロー) のキャンセルでは null になり、代わりに uenoRereservationRequest が入る。 */
	rereservation: Maybe<RereservationV2>
	/** 上野クリニック専用の再来カウンセリング受付内容。上野は確定済み再予約を作らず希望枠の受付のみ行うため、rereservation の代わりにこちらが入る。上野以外のキャンセルでは null。 */
	uenoRereservationRequest: Maybe<UenoRereservationRequestV1>
}

export type ReservableSlot = {
	durationMinute: Scalars["Int"]["output"]
	startHour: Scalars["Hour"]["output"]
	startMinute: Scalars["Minute"]["output"]
}

export type ReservableSlotV2 = {
	durationMinute: Scalars["Int"]["output"]
	/**
	 * staggeredSchedulingEnabled が true の場合、この枠を開始時間とした予約が禁止されているかどうか
	 * - 設備枠として ReservableSlotV2 が使われる場合、Nabeko が明示的に false を設定して返す（設備にはずらし設定がないため）
	 */
	isUnavailableAsStartSlotIfStaggeredScheduling: Scalars["Boolean"]["output"]
	startHour: Scalars["Hour"]["output"]
	startMinute: Scalars["Minute"]["output"]
}

export type ReservableSlotsWithEquipmentChunkV2 = {
	equipment: Equipment
	reservableSlots: Array<ReservableSlotV2>
}

export type ReservableSlotsWithStaffChunk = {
	reservableSlots: Array<ReservableSlot>
	staff: Staff
}

export type ReservableSlotsWithStaffChunkV2 = {
	reservableSlots: Array<ReservableSlotV2>
	staff: StaffV2
}

export type ReservationPageEnabledFeatures = {
	/**
	 * キャンセル予約時とは別のスタッフでの予約を許可する機能
	 * - FE では、この値が true かつ顧客の visit_count < 1 (新規客) のときだけ他スタッフ枠を表示する。
	 *   false の場合は visit_count に関わらず他スタッフ枠を表示しない。
	 */
	allowsDifferentStaffReservation: Scalars["Boolean"]["output"]
	/**
	 * 　再予約通知の配信停止ボタンを再予約画面に表示する機能
	 *   - trueの場合
	 *     - 再予約画面に再予約通知の配信停止ボタンを表示する
	 *     - ボタンを押すと今後一切再予約URLが送信されなくなる
	 */
	enableAbortEncouragingReservationButton: Scalars["Boolean"]["output"]
	/**
	 * 予約枠を一定期間キャッシュする機能
	 * - true の場合
	 *   - 70 分以内にキャッシュされた予約枠が存在すれば、その値を返します。予約枠キャッシュは、この API が呼ばれた時、もしくは1時間に一度呼ばれる job (未作成) により、作成されます。
	 *   - 予約作成時、予約枠が空いているか確認し、空いている場合は予約を作成、空いていなければ SLOT_UNAVAILABLE_TO_CREATE_RESERVATION を返す
	 * - false の場合
	 *   - 予約作成時に、予約枠が空いているかの確認をせずに、予約を作成します (TODO: 将来変わる可能性あり)
	 */
	enableSlotCaching: Scalars["Boolean"]["output"]
	/**
	 * 再予約画面の予約確定確認モーダルにキャンセルポリシー（キャンセル料率の一覧）を表示しない機能
	 * - true の場合、FE は予約確定の確認モーダルにキャンセルポリシーを表示しない
	 * - 現在は全店舗で非表示のため常に true を返す (feature flag による店舗ごとの出し分けは廃止)
	 * - 表示のみの機能で、キャンセル料の請求条件そのものには影響しない
	 */
	hidesCancelPolicy: Scalars["Boolean"]["output"]
	/**
	 * 前回予約の詳細 (メニュー・スタッフ・予約番号・価格等) を再予約画面で表示しない機能
	 * - true の場合、FE はお名前・前回来店予定日・電話番号のみ表示する
	 * - 媒体 (dataSource) によって出し分ける。data_source_policy.go の DataSource.HidesReservationDetailsOnRereservationPage で制御する。(feature flag は使わない)
	 * - 上野クリニック (スプレッドシート) など、詳細データを持たない媒体で true になる
	 */
	hidesReservationDetails: Scalars["Boolean"]["output"]
	/**
	 * 再予約の確認画面に「※次回予約メニューの場合、通常価格でのご案内となることがございます」の注意書きを表示する機能
	 * - true の場合、FE は予約確定の確認モーダルに上記の注意書きを表示する
	 * - feature flag SHOW_NEXT_RESERVATION_MENU_REGULAR_PRICE_NOTE で店舗ごとに ON/OFF する
	 * - 表示のみの機能で、予約金額そのものには影響しない
	 */
	showsNextReservationMenuRegularPriceNote: Scalars["Boolean"]["output"]
}

export type Salon = {
	allowFreeStaffReservation: Scalars["Boolean"]["output"]
	availableStaffs: Array<Staff>
	cancelConditionTextsForMenu: Array<Scalars["String"]["output"]>
	cancelConditionTextsForNoMenu: Array<Scalars["String"]["output"]>
	durationMinuteForEmptyMenu: Maybe<Scalars["Int"]["output"]>
	forceEmptyWhenCannotReserveCanceledReservationMenuSet: Scalars["Boolean"]["output"]
	iconUrl: Maybe<Scalars["String"]["output"]>
	id: Scalars["Int"]["output"]
	name: Scalars["String"]["output"]
}

export type SalonV2 = {
	/** 店舗住所 (IDP の SalonBasicInfo.address 由来)。 */
	address: Maybe<Scalars["String"]["output"]>
	cancelConditionTextsForMenu: Array<Scalars["String"]["output"]>
	cancelConditionTextsForNoMenu: Array<Scalars["String"]["output"]>
	/** 再予約完了画面に表示する、キャンセル・日程変更の連絡先 URL (公式 LINE 等)。未設定のサロンでは null。null の場合 FE は従来の固定文言 (店舗に電話) を表示する。値は oneshot SQL で souhl 側が直接設定する。設定用の API はない。 */
	contactUrl: Maybe<Scalars["String"]["output"]>
	headerImageUrl: Maybe<Scalars["String"]["output"]>
	iconUrl: Maybe<Scalars["String"]["output"]>
	id: Scalars["Int"]["output"]
	name: Scalars["String"]["output"]
}

export type SevenDaysReservableSlotsChunksParam = {
	cancelId: Scalars["String"]["input"]
	fromDate: Scalars["Date"]["input"]
}

export type SevenDaysReservableSlotsChunksResponse = {
	chunks: Array<DateReservableSlots>
}

/**
 * ほとんどのロジックはnabekoに委譲する予定だが、一旦cancyが持つ
 * - enableSlotCaching feature が有効な店舗の場合
 *     - 数時間周期で更新されるキャッシュ枠を返します。
 *     - TODO: detail
 * - TODO:
 */
export type SevenDaysReservableSlotsChunksV2Param = {
	cancelId: Scalars["String"]["input"]
	fromDate: Scalars["Date"]["input"]
}

export type SevenDaysReservableSlotsChunksV2Response = {
	/**
	 * SevenDaysReservableSlotsChunksV2Response は、7日間の予約枠を返します。
	 * - TODO: 既存の仕様を書く
	 * - 分析用途で、取得した予約枠は、req_id をキーに db に記録されます。
	 * - FeatureFlug.enableSlotCaching=trueの店舗では,当日から7日分の新しいキャッシュがあり、fromDateが当日の場合その予約枠を返します。
	 * - このAPIによってキャッシュが返されない場合は、キャッシュを更新します。
	 * - キャッシュの有効期限は70分です。
	 * - [recommendedSlots]
	 *   - RecommendedSlotとして、取得した予約枠の中でstaffが同じで実行時間よりも後のものを、start_time順に最大4枠返します。
	 *   - 予約枠は、必要な施術時間分の連続した空き枠があるかどうかを確認します（例: 60分の施術には30分枠×2つが連続している必要があります）
	 *   - needSameEquipmentAsPreviousToCreateReservation=true の場合は、空の配列を返します。needAnyReservableEquipmentToCreateReservation の logic より優先されます。
	 *     - 理由: 前回と同じ設備が必要だが、このAPIのコンテキストにはどの設備かの情報がないため、
	 *       正しい推奨枠を計算できない
	 *     - TODO: 対応
	 *   - 設備情報が必要な媒体（needAnyReservableEquipmentToCreateReservation=true）では、RecommendedSlotに設備IDと設備名が合わせて返されます。
	 *     - RecommendedSlotの選定条件:
	 *       1. スタッフの予約可能枠が連続して空いている
	 *       2. 同じ時間帯に設備が連続して空いている
	 *     - 複数の設備が利用可能な場合、最初に見つかった設備を返します（設備はすべて等価として扱われます）
	 *   - 設備情報が不要な媒体（needSameEquipmentAsPreviousToCreateReservation=false かつ needAnyReservableEquipmentToCreateReservation=false）では、スタッフの空き状況のみを確認してRecommendedSlotを返します。
	 *   - staggeredSchedulingEnabled=true の場合、isUnavailableAsStartSlotIfStaggeredScheduling=true の枠を除外した recommendedSlots を返します
	 * - 下記の場合は 空の chunks, recommendedSlots を返し、warning log を出力します。
	 *   - 各媒体の媒体設定が誤っている場合
	 *   - [beauty_merit]
	 *     - 権限エラーの場合
	 *   - [exceed]
	 *     - salonboard の 媒体設定がない、もしくは間違っている場合
	 *       - (exceed は exceed だけでなく、 salonboard の媒体情報も必要)
	 *
	 * - [各媒体の特徴]
	 *   - [exceed]
	 *     - salonboard から予約枠を取得し、chunks.reservableSlotsWithStaffChunks.staff を 下記の条件を満たしたときに exceed のスタッフに差し替えます。
	 *       - [staff.name] と [exceed の API から取得したスタッフ名]をそれぞれ正規化処理(※1)したもの が一致する
	 *       - data_source_staff_mappings に salonboard と exceed の id の紐付けが存在する
	 *     - どちらの条件も満たさなかった場合は、warning log が出力され、その枠は返されません。
	 *     ※1: 正規化処理の仕様は go/modules/nabeko/internal/domain/model/normalize.go の NormalizeStaffName を参照
	 *
	 *     - salonboardでフリーの予約枠が取得された場合は、chunks.reservableSlotsWithStaffChunks.staff.scrapingTargetSiteIdをEXCEED_FREE_STAFF_IDに置き換えて枠を返します。
	 *   - [all_booking_platforms]
	 *     - salonboard のデータを返す
	 *   - [salon_connect]
	 *     - 設備を必ず指定する必要があるため、reservableSlotsWithEquipmentChunks から具体的な equipment_id を選んで予約する。他の設備を使う媒体 (SalonBoard / BeautyMerit) と同じ扱い。
	 *   - [saloriza]
	 *     - salonbaord のデータを返す
	 */
	_nabekoInfo: Scalars["Boolean"]["output"]
	cacheReqId: Maybe<Scalars["String"]["output"]>
	chunks: Array<DateReservableSlotsV2>
	dataSourceStaffId: Scalars["String"]["output"]
	durationMinute: Scalars["Int"]["output"]
	fromDate: Scalars["Date"]["output"]
	/**
	 * 予約作成時に何らかの設備が空いている必要があるかどうか
	 * - true の場合、何らかの設備が空いていれば予約可能
	 * - NOTE: needSameEquipmentAsPreviousToCreateReservation と両方 true になることは想定していない。
	 *   もし両方 true の場合は needSameEquipmentAsPreviousToCreateReservation を優先すること（より厳しい条件のため）
	 */
	needAnyReservableEquipmentToCreateReservation: Scalars["Boolean"]["output"]
	/**
	 * 前回予約の設備が空いている予約枠のみを表示するかどうか
	 * - true の場合、前回予約と同じ設備が空いている場合のみ予約可能
	 * - special_salons.go にハードコーディングされている店舗のみ true が返される
	 * - NOTE: needAnyReservableEquipmentToCreateReservation と両方 true になることは想定していない。
	 *   もし両方 true の場合はこちらを優先すること（より厳しい条件のため）
	 */
	needSameEquipmentAsPreviousToCreateReservation: Scalars["Boolean"]["output"]
	recommendedSlots: Array<RecommendedSlot>
	salonId: Scalars["Int"]["output"]
	/**
	 * ずらし設定の考慮が必要かどうか
	 * - true: FE は ReservableSlotV2.isUnavailableAsStartSlotIfStaggeredScheduling を参照し、
	 *   true の枠をそのスタッフでは予約できないようにする
	 * - false: FE は isUnavailableAsStartSlotIfStaggeredScheduling を無視し、通常通り表示する
	 * - special_salons.go の staggeredSchedulingEnabledSalonIDs に含まれる salon_id の場合に true が返される
	 */
	staggeredSchedulingEnabled: Scalars["Boolean"]["output"]
	/**
	 * 2枠受付モードかどうか
	 * - true: FE は再予約画面で 2 枠の予約を受け付けられるようにする
	 * - false: 従来どおり 1 枠のみ受け付ける
	 * - 媒体 (DataSourcePolicy) によって決まる。data_source_policy.go の DataSourcePolicy.TwoSlotsReservationEnabled で制御する
	 */
	twoSlotsReservationEnabled: Scalars["Boolean"]["output"]
}

export type Staff = {
	id: Scalars["String"]["output"]
	name: Scalars["String"]["output"]
}

export type StaffV2 = {
	name: Scalars["String"]["output"]
	scrapingTargetSiteId: Scalars["String"]["output"]
}

export type TreatableStaff = {
	/**
	 * 　スタッフ名
	 *
	 */
	name: Scalars["String"]["output"]
	/** スタッフID */
	scrapingTargetSiteStaffId: Scalars["String"]["output"]
}

export type UenoRereservationRequestV1 = {
	cancelId: Scalars["String"]["output"]
	firstStartTime: Scalars["DateTime"]["output"]
	registerTime: Scalars["DateTime"]["output"]
	secondStartTime: Maybe<Scalars["DateTime"]["output"]>
}

/** UenoRereservationRequestV1 query は、上野クリニック専用の再来カウンセリング受付内容を取得します。 */
export type UenoRereservationRequestV1Param = {
	cancelId: Scalars["String"]["input"]
}

export type UenoRereservationRequestV1Response = {
	uenoRereservationRequest: UenoRereservationRequestV1
}

/** UpsertRereservedCustomerEmail mutation は、予約後にリマインドメールを送信するアドレスを登録・更新する。 */
export type UpsertRereservedCustomerEmailInput = {
	cancelId: Scalars["String"]["input"]
	rereservedCustomerEmail: Scalars["String"]["input"]
}

export type UpsertRereservedCustomerEmailResponse = {
	cancelId: Scalars["String"]["output"]
}

export type Join__Graph =
	| "CANCY_PUBLIC_RERESERVATION"
	| "NABEKO_PUBLIC_RESERVATION_SETTING"

export type Link__Purpose =
	/** `EXECUTION` features provide metadata necessary for operation execution. */
	| "EXECUTION"
	/** `SECURITY` features provide metadata necessary to securely resolve fields. */
	| "SECURITY"

export type RecommendedSlotFragment = {
	date: string
	slot: { startHour: Hour; startMinute: Minute }
	staff: { scrapingTargetSiteId: string; name: string }
	equipment: { id: string; name: string } | null
} & { " $fragmentName"?: "RecommendedSlotFragment" }

export type LotteryBannerFragment = {
	price: number
	lotteryMultiplier: number | null
} & { " $fragmentName"?: "LotteryBannerFragment" }

export type RereservationIncentiveBannerFragment = ({
	price: number
	type: RereservationIncentiveTypeEnum
} & { " $fragmentRefs"?: { LotteryBannerFragment: LotteryBannerFragment } }) & {
	" $fragmentName"?: "RereservationIncentiveBannerFragment"
}

export type GetSevenDaysReservableSlotsChunksQueryVariables = Exact<{
	param: SevenDaysReservableSlotsChunksParam
}>

export type GetSevenDaysReservableSlotsChunksQuery = {
	sevenDaysReservableSlotsChunks: {
		chunks: Array<{
			" $fragmentRefs"?: {
				DateReservableSlotsFragment: DateReservableSlotsFragment
			}
		}>
	}
}

export type GetSevenDaysReservableSlotsChunksV2QueryVariables = Exact<{
	param: SevenDaysReservableSlotsChunksV2Param
}>

export type GetSevenDaysReservableSlotsChunksV2Query = {
	sevenDaysReservableSlotsChunksV2: {
		cacheReqId: string | null
		needAnyReservableEquipmentToCreateReservation: boolean
		needSameEquipmentAsPreviousToCreateReservation: boolean
		staggeredSchedulingEnabled: boolean
		chunks: Array<{
			" $fragmentRefs"?: {
				DateReservableSlotsV2Fragment: DateReservableSlotsV2Fragment
			}
		}>
		recommendedSlots: Array<{
			" $fragmentRefs"?: { RecommendedSlotFragment: RecommendedSlotFragment }
		}>
	}
}

export type GetCanceledReservationQueryVariables = Exact<{
	param: CanceledReservationParam
}>

export type GetCanceledReservationQuery = {
	canceledReservation: {
		isRereserved: boolean
		canceledReservation: {
			cancelId: string
			canReserveCanceledReservationMenusSet: boolean
			price: number
			durationMinute: number
			customer: { id: string; name: string }
			menusAndCoupons: { names: Array<string> }
			staff: { id: string; name: string } | null
		}
		salon: {
			name: string
			iconUrl: string | null
			durationMinuteForEmptyMenu: number | null
			allowFreeStaffReservation: boolean
			cancelConditionTextsForMenu: Array<string>
			cancelConditionTextsForNoMenu: Array<string>
			forceEmptyWhenCannotReserveCanceledReservationMenuSet: boolean
			availableStaffs: Array<{ id: string; name: string }>
		}
	}
}

export type CreateRereservationMutationVariables = Exact<{
	input: CreateRereservationInput
}>

export type CreateRereservationMutation = {
	createRereservation: { __typename: "CreateRereservationResponse" }
}

export type GetCanceledReservationV2QueryVariables = Exact<{
	param: CanceledReservationV2Param
}>

export type GetCanceledReservationV2Query = {
	canceledReservationV2: {
		isRereserved: boolean
		salon: {
			id: number
			iconUrl: string | null
			headerImageUrl: string | null
			name: string
			cancelConditionTextsForMenu: Array<string>
			cancelConditionTextsForNoMenu: Array<string>
		}
		customer: { id: string; name: string; phoneNumber: string | null }
		canceledReservation: {
			cancelId: string
			reserveId: string
			visitDate: string
			price: number
			durationMinute: number
			menuOrCouponNames: Array<string>
			equipmentIds: Array<string>
			visitCount: number
			hidesStaffDueToNotNominated: boolean
			dataSource: DataSource
			useClaimingConversionRecancelPolicy: boolean
			incentive: {
				" $fragmentRefs"?: {
					RereservationIncentiveBannerFragment: RereservationIncentiveBannerFragment
					LotteryNoteSectionFragment: LotteryNoteSectionFragment
				}
			} | null
			enabledFeatures: {
				allowsDifferentStaffReservation: boolean
				enableAbortEncouragingReservationButton: boolean
				enableSlotCaching: boolean
				hidesReservationDetails: boolean
				showsNextReservationMenuRegularPriceNote: boolean
				hidesCancelPolicy: boolean
			}
			staff: { scrapingTargetSiteId: string; name: string }
			treatableStaffs: Array<{
				" $fragmentRefs"?: { TreatableStaffFragment: TreatableStaffFragment }
			}>
		}
	}
}

export type CreateRereservationV2MutationVariables = Exact<{
	input: CreateRereservationV2Input
}>

export type CreateRereservationV2Mutation = {
	createRereservationV2: { __typename: "CreateRereservationV2Response" }
}

export type CreateUenoRereservationRequestMutationVariables = Exact<{
	input: CreateUenoRereservationRequestInput
}>

export type CreateUenoRereservationRequestMutation = {
	createUenoRereservationRequest: {
		__typename: "CreateUenoRereservationRequestResponse"
	}
}

export type MarkLotteryTicketAsShownMutationVariables = Exact<{
	input: MarkLotteryTicketAsShownInput
}>

export type MarkLotteryTicketAsShownMutation = {
	markLotteryTicketAsShown: { __typename: "MarkLotteryTicketAsShownResponse" }
}

export type TreatableStaffFragment = {
	scrapingTargetSiteStaffId: string
	name: string
} & { " $fragmentName"?: "TreatableStaffFragment" }

export type DateReservableSlotsFragment = {
	date: string
	reservableStartHour: Hour
	reservableStartMinute: Minute
	reservableEndHour: Hour
	reservableEndMinute: Minute
	reservableSlotsWithStaffChunks: Array<{
		staff: { id: string; name: string }
		reservableSlots: Array<{
			startHour: Hour
			startMinute: Minute
			durationMinute: number
		}>
	}>
	reservableSlotsWithoutStaff: Array<{
		startHour: Hour
		startMinute: Minute
		durationMinute: number
	}>
} & { " $fragmentName"?: "DateReservableSlotsFragment" }

export type DateReservableSlotsV2Fragment = {
	date: string
	reservableStartHour: Hour
	reservableStartMinute: Minute
	reservableEndHour: Hour
	reservableEndMinute: Minute
	reservableSlotsWithStaffChunks: Array<{
		reservableSlots: Array<{
			startHour: Hour
			startMinute: Minute
			durationMinute: number
			isUnavailableAsStartSlotIfStaggeredScheduling: boolean
		}>
		staff: { scrapingTargetSiteId: string; name: string }
	}>
	reservableSlotsWithEquipmentChunks: Array<{
		equipment: { id: string; name: string }
		reservableSlots: Array<{
			startHour: Hour
			startMinute: Minute
			durationMinute: number
		}>
	}>
} & { " $fragmentName"?: "DateReservableSlotsV2Fragment" }

export type LotteryNoteSectionFragment = {
	type: RereservationIncentiveTypeEnum
	price: number
	lotteryMultiplier: number | null
} & { " $fragmentName"?: "LotteryNoteSectionFragment" }

export type GetRereservationQueryVariables = Exact<{
	param: RereservationParam
}>

export type GetRereservationQuery = {
	Rereservation: {
		id: string
		startTime: string
		price: number
		durationMinute: number
		useClaimingConversionRecancelPolicy: boolean
		customer: { name: string }
		staff: { name: string } | null
		menusAndCoupons: { names: Array<string> }
		salon: {
			name: string
			durationMinuteForEmptyMenu: number | null
			cancelConditionTextsForMenu: Array<string>
			cancelConditionTextsForNoMenu: Array<string>
		}
	}
}

export type GetRereservationV2QueryVariables = Exact<{
	param: RereservationV2Param
}>

export type GetRereservationV2Query = {
	rereservationV2: {
		rereservation: {
			cancelId: string
			menuOrCouponNames: Array<string>
			startTime: string
			price: number
			durationMinute: number
			useClaimingConversionRecancelPolicy: boolean
			customer: { id: string; name: string }
			staff: { scrapingTargetSiteId: string; name: string }
			salon: {
				id: number
				iconUrl: string | null
				name: string
				cancelConditionTextsForMenu: Array<string>
				cancelConditionTextsForNoMenu: Array<string>
				contactUrl: string | null
			}
		} | null
	}
}

export type GetUenoRereservationRequestV1QueryVariables = Exact<{
	param: UenoRereservationRequestV1Param
}>

export type GetUenoRereservationRequestV1Query = {
	uenoRereservationRequestV1: {
		uenoRereservationRequest: {
			cancelId: string
			firstStartTime: string
			secondStartTime: string | null
		}
	}
}

export type GetCanceledReservationV2ForCompletePageQueryVariables = Exact<{
	param: CanceledReservationV2Param
}>

export type GetCanceledReservationV2ForCompletePageQuery = {
	canceledReservationV2: {
		customer: { name: string; phoneNumber: string | null }
		canceledReservation: { cancelId: string; dataSource: DataSource } & {
			" $fragmentRefs"?: { EmailSectionFragment: EmailSectionFragment }
		}
	}
}

export type UpsertRereservedCustomerEmailMutationVariables = Exact<{
	input: UpsertRereservedCustomerEmailInput
}>

export type UpsertRereservedCustomerEmailMutation = {
	upsertRereservedCustomerEmail: {
		__typename: "UpsertRereservedCustomerEmailResponse"
	}
}

export type EmailSectionFragment = ({
	incentive: {
		type: RereservationIncentiveTypeEnum
		lotteryMultiplier: number | null
	} | null
} & {
	" $fragmentRefs"?: {
		LotteryEmailSectionFragment: LotteryEmailSectionFragment
	}
}) & { " $fragmentName"?: "EmailSectionFragment" }

export type LotteryEmailSectionFragment = {
	registeredEmailByRereservationForm: string | null
	incentive: { lotteryMultiplier: number | null } | null
} & { " $fragmentName"?: "LotteryEmailSectionFragment" }

export const RecommendedSlotFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "recommendedSlot" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "RecommendedSlot" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "slot" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "startHour" } },
								{ kind: "Field", name: { kind: "Name", value: "startMinute" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "date" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "staff" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "scrapingTargetSiteId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "name" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "equipment" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "name" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<RecommendedSlotFragment, unknown>
export const LotteryBannerFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "lotteryBanner" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "RereservationIncentiveOutput" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "price" } },
					{ kind: "Field", name: { kind: "Name", value: "lotteryMultiplier" } },
				],
			},
		},
	],
} as unknown as DocumentNode<LotteryBannerFragment, unknown>
export const RereservationIncentiveBannerFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "rereservationIncentiveBanner" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "RereservationIncentiveOutput" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "price" } },
					{ kind: "Field", name: { kind: "Name", value: "type" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "lotteryBanner" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "lotteryBanner" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "RereservationIncentiveOutput" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "price" } },
					{ kind: "Field", name: { kind: "Name", value: "lotteryMultiplier" } },
				],
			},
		},
	],
} as unknown as DocumentNode<RereservationIncentiveBannerFragment, unknown>
export const TreatableStaffFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "treatableStaff" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TreatableStaff" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "scrapingTargetSiteStaffId" },
					},
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
	],
} as unknown as DocumentNode<TreatableStaffFragment, unknown>
export const DateReservableSlotsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "dateReservableSlots" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "DateReservableSlots" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "date" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableStartHour" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableStartMinute" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reservableEndHour" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableEndMinute" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableSlotsWithStaffChunks" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "staff" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "reservableSlots" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "startHour" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "startMinute" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "durationMinute" },
											},
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableSlotsWithoutStaff" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "startHour" } },
								{ kind: "Field", name: { kind: "Name", value: "startMinute" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "durationMinute" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<DateReservableSlotsFragment, unknown>
export const DateReservableSlotsV2FragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "dateReservableSlotsV2" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "DateReservableSlotsV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "date" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableStartHour" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableStartMinute" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reservableEndHour" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableEndMinute" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableSlotsWithStaffChunks" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "reservableSlots" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "startHour" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "startMinute" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "durationMinute" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value:
														"isUnavailableAsStartSlotIfStaggeredScheduling",
												},
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "staff" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "scrapingTargetSiteId" },
											},
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableSlotsWithEquipmentChunks" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "equipment" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "reservableSlots" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "startHour" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "startMinute" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "durationMinute" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<DateReservableSlotsV2Fragment, unknown>
export const LotteryNoteSectionFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "lotteryNoteSection" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "RereservationIncentiveOutput" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "type" } },
					{ kind: "Field", name: { kind: "Name", value: "price" } },
					{ kind: "Field", name: { kind: "Name", value: "lotteryMultiplier" } },
				],
			},
		},
	],
} as unknown as DocumentNode<LotteryNoteSectionFragment, unknown>
export const LotteryEmailSectionFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "lotteryEmailSection" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CanceledReservationV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "registeredEmailByRereservationForm" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "incentive" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "lotteryMultiplier" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<LotteryEmailSectionFragment, unknown>
export const EmailSectionFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "emailSection" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CanceledReservationV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "incentive" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "type" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "lotteryMultiplier" },
								},
							],
						},
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "lotteryEmailSection" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "lotteryEmailSection" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CanceledReservationV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "registeredEmailByRereservationForm" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "incentive" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "lotteryMultiplier" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<EmailSectionFragment, unknown>
export const GetSevenDaysReservableSlotsChunksDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSevenDaysReservableSlotsChunks" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "SevenDaysReservableSlotsChunksParam",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "sevenDaysReservableSlotsChunks" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "chunks" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "dateReservableSlots" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "dateReservableSlots" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "DateReservableSlots" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "date" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableStartHour" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableStartMinute" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reservableEndHour" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableEndMinute" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableSlotsWithStaffChunks" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "staff" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "reservableSlots" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "startHour" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "startMinute" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "durationMinute" },
											},
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableSlotsWithoutStaff" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "startHour" } },
								{ kind: "Field", name: { kind: "Name", value: "startMinute" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "durationMinute" },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetSevenDaysReservableSlotsChunksQuery,
	GetSevenDaysReservableSlotsChunksQueryVariables
>
export const GetSevenDaysReservableSlotsChunksV2Document = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetSevenDaysReservableSlotsChunksV2" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "SevenDaysReservableSlotsChunksV2Param",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "sevenDaysReservableSlotsChunksV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "cacheReqId" } },
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "needAnyReservableEquipmentToCreateReservation",
									},
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "needSameEquipmentAsPreviousToCreateReservation",
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "staggeredSchedulingEnabled" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "chunks" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "dateReservableSlotsV2" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "recommendedSlots" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "recommendedSlot" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "dateReservableSlotsV2" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "DateReservableSlotsV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "date" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableStartHour" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableStartMinute" },
					},
					{ kind: "Field", name: { kind: "Name", value: "reservableEndHour" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableEndMinute" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableSlotsWithStaffChunks" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "reservableSlots" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "startHour" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "startMinute" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "durationMinute" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value:
														"isUnavailableAsStartSlotIfStaggeredScheduling",
												},
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "staff" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "scrapingTargetSiteId" },
											},
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "reservableSlotsWithEquipmentChunks" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "equipment" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "reservableSlots" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "startHour" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "startMinute" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "durationMinute" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "recommendedSlot" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "RecommendedSlot" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "slot" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "startHour" } },
								{ kind: "Field", name: { kind: "Name", value: "startMinute" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "date" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "staff" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "scrapingTargetSiteId" },
								},
								{ kind: "Field", name: { kind: "Name", value: "name" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "equipment" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "name" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetSevenDaysReservableSlotsChunksV2Query,
	GetSevenDaysReservableSlotsChunksV2QueryVariables
>
export const GetCanceledReservationDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCanceledReservation" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CanceledReservationParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "canceledReservation" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "canceledReservation" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "cancelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "customer" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "id" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "name" },
														},
													],
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "canReserveCanceledReservationMenusSet",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "menusAndCoupons" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "names" },
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "staff" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "id" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "name" },
														},
													],
												},
											},
											{ kind: "Field", name: { kind: "Name", value: "price" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "durationMinute" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "isRereserved" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "iconUrl" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "durationMinuteForEmptyMenu",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "allowFreeStaffReservation",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "cancelConditionTextsForMenu",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "cancelConditionTextsForNoMenu",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "availableStaffs" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "id" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "name" },
														},
													],
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value:
														"forceEmptyWhenCannotReserveCanceledReservationMenuSet",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCanceledReservationQuery,
	GetCanceledReservationQueryVariables
>
export const CreateRereservationDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateRereservation" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CreateRereservationInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createRereservation" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "__typename" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateRereservationMutation,
	CreateRereservationMutationVariables
>
export const GetCanceledReservationV2Document = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCanceledReservationV2" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CanceledReservationV2Param" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "canceledReservationV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "isRereserved" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "iconUrl" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "headerImageUrl" },
											},
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "cancelConditionTextsForMenu",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "cancelConditionTextsForNoMenu",
												},
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "customer" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "phoneNumber" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "canceledReservation" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "cancelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "reserveId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "visitDate" },
											},
											{ kind: "Field", name: { kind: "Name", value: "price" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "durationMinute" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "menuOrCouponNames" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "equipmentIds" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "visitCount" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "hidesStaffDueToNotNominated",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "dataSource" },
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "useClaimingConversionRecancelPolicy",
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "incentive" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "FragmentSpread",
															name: {
																kind: "Name",
																value: "rereservationIncentiveBanner",
															},
														},
														{
															kind: "FragmentSpread",
															name: {
																kind: "Name",
																value: "lotteryNoteSection",
															},
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "enabledFeatures" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "allowsDifferentStaffReservation",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value:
																	"enableAbortEncouragingReservationButton",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "enableSlotCaching",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "hidesReservationDetails",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value:
																	"showsNextReservationMenuRegularPriceNote",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "hidesCancelPolicy",
															},
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "staff" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "scrapingTargetSiteId",
															},
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "name" },
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "treatableStaffs" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "FragmentSpread",
															name: { kind: "Name", value: "treatableStaff" },
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "lotteryBanner" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "RereservationIncentiveOutput" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "price" } },
					{ kind: "Field", name: { kind: "Name", value: "lotteryMultiplier" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "rereservationIncentiveBanner" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "RereservationIncentiveOutput" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "price" } },
					{ kind: "Field", name: { kind: "Name", value: "type" } },
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "lotteryBanner" },
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "lotteryNoteSection" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "RereservationIncentiveOutput" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "type" } },
					{ kind: "Field", name: { kind: "Name", value: "price" } },
					{ kind: "Field", name: { kind: "Name", value: "lotteryMultiplier" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "treatableStaff" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "TreatableStaff" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "scrapingTargetSiteStaffId" },
					},
					{ kind: "Field", name: { kind: "Name", value: "name" } },
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCanceledReservationV2Query,
	GetCanceledReservationV2QueryVariables
>
export const CreateRereservationV2Document = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateRereservationV2" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CreateRereservationV2Input" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createRereservationV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "__typename" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateRereservationV2Mutation,
	CreateRereservationV2MutationVariables
>
export const CreateUenoRereservationRequestDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "CreateUenoRereservationRequest" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "CreateUenoRereservationRequestInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createUenoRereservationRequest" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "__typename" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	CreateUenoRereservationRequestMutation,
	CreateUenoRereservationRequestMutationVariables
>
export const MarkLotteryTicketAsShownDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "MarkLotteryTicketAsShown" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "MarkLotteryTicketAsShownInput" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "markLotteryTicketAsShown" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "__typename" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	MarkLotteryTicketAsShownMutation,
	MarkLotteryTicketAsShownMutationVariables
>
export const GetRereservationDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetRereservation" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "RereservationParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "Rereservation" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "customer" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "staff" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "name" } },
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "menusAndCoupons" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "names" } },
										],
									},
								},
								{ kind: "Field", name: { kind: "Name", value: "startTime" } },
								{ kind: "Field", name: { kind: "Name", value: "price" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "durationMinute" },
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "salon" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "durationMinuteForEmptyMenu",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "cancelConditionTextsForMenu",
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "cancelConditionTextsForNoMenu",
												},
											},
										],
									},
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "useClaimingConversionRecancelPolicy",
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetRereservationQuery,
	GetRereservationQueryVariables
>
export const GetRereservationV2Document = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetRereservationV2" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "RereservationV2Param" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "rereservationV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "rereservation" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "cancelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "customer" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "id" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "name" },
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "menuOrCouponNames" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "staff" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "scrapingTargetSiteId",
															},
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "name" },
														},
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "startTime" },
											},
											{ kind: "Field", name: { kind: "Name", value: "price" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "durationMinute" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "salon" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "id" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "iconUrl" },
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "name" },
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancelConditionTextsForMenu",
															},
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancelConditionTextsForNoMenu",
															},
														},
														{
															kind: "Field",
															name: { kind: "Name", value: "contactUrl" },
														},
													],
												},
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "useClaimingConversionRecancelPolicy",
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetRereservationV2Query,
	GetRereservationV2QueryVariables
>
export const GetUenoRereservationRequestV1Document = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetUenoRereservationRequestV1" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "UenoRereservationRequestV1Param" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "uenoRereservationRequestV1" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "uenoRereservationRequest" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "cancelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "firstStartTime" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "secondStartTime" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetUenoRereservationRequestV1Query,
	GetUenoRereservationRequestV1QueryVariables
>
export const GetCanceledReservationV2ForCompletePageDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "GetCanceledReservationV2ForCompletePage" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "CanceledReservationV2Param" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "canceledReservationV2" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "customer" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "name" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "phoneNumber" },
											},
										],
									},
								},
								{
									kind: "Field",
									name: { kind: "Name", value: "canceledReservation" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "cancelId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "dataSource" },
											},
											{
												kind: "FragmentSpread",
												name: { kind: "Name", value: "emailSection" },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "lotteryEmailSection" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CanceledReservationV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "registeredEmailByRereservationForm" },
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "incentive" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "lotteryMultiplier" },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "emailSection" },
			typeCondition: {
				kind: "NamedType",
				name: { kind: "Name", value: "CanceledReservationV2" },
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "incentive" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "type" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "lotteryMultiplier" },
								},
							],
						},
					},
					{
						kind: "FragmentSpread",
						name: { kind: "Name", value: "lotteryEmailSection" },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCanceledReservationV2ForCompletePageQuery,
	GetCanceledReservationV2ForCompletePageQueryVariables
>
export const UpsertRereservedCustomerEmailDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "UpsertRereservedCustomerEmail" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "input" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "UpsertRereservedCustomerEmailInput",
							},
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "upsertRereservedCustomerEmail" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "input" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "__typename" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpsertRereservedCustomerEmailMutation,
	UpsertRereservedCustomerEmailMutationVariables
>
